module.exports = __webpack_public_path__ + "static/media/new-login-hero.70b22767.png";